import { INDUSTRIES_A } from './industriesA';
import { INDUSTRIES_B } from './industriesB';

export const INDUSTRIES = { ...INDUSTRIES_A, ...INDUSTRIES_B };

export const INDUSTRY_CATEGORIES = [
  'Manufacturing & Industrial',
  'Real Estate & Infrastructure',
  'Healthcare & Life Sciences',
  'Technology & Services',
  'Trade & Commerce',
  'Education'
];
